import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { repertoire, allTags } from '../data/repertoire';
import { MusicIcon } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Repertoire() {
  useSEO({
    title: 'Repertoire – Tuesday Liveband Kempten | Pop, Rock & Coversongs',
    description: 'Setlist & Repertoire der Liveband Tuesday aus Kempten im Allgäu. Von Pop und Rock über deutschsprachige Hits bis zu Balladen und Party-Covern, individuell abstimmbar.',
    path: '/repertoire'
  });
  const [activeFilter, setActiveFilter] = useState<string>('Alle');
  const filters = ['Alle', ...allTags];
  const filteredSongs = activeFilter === 'Alle' ? repertoire : repertoire.filter(song => song.tags.includes(activeFilter));
  return <div className="w-full min-h-screen py-16 px-4 sm:px-6 lg:px-8" data-id="element-263">
      <div className="max-w-7xl mx-auto" data-id="element-264">
        <motion.div {...fadeInUp} className="text-center mb-12" data-id="element-265">
          <h1 className="font-display text-5xl sm:text-6xl font-bold text-primary mb-6" data-id="element-266">
            Repertoire
          </h1>
          <p className="text-muted text-lg max-w-3xl mx-auto" data-id="element-267">
            Dies ist unser aktuelles Beispielrepertoire. Sets können individuell
            auf euer Event abgestimmt werden.
          </p>
        </motion.div>

        {/* Filter Tabs */}
        <motion.div {...fadeInUp} className="mb-8 overflow-x-auto" data-id="element-268">
          <div className="flex flex-wrap gap-2 justify-center min-w-max px-4" data-id="element-269">
            {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${activeFilter === filter ? 'bg-accent text-[var(--color-text-inv)]' : 'bg-surface text-muted border border-border-base hover:border-accent hover:text-accent'}`} data-id="element-270">
                {filter}
              </button>)}
          </div>
        </motion.div>

        {/* Desktop Table */}
        <motion.div {...fadeInUp} className="hidden md:block bg-surface border border-border-base rounded-lg overflow-hidden" data-id="element-271">
          <table className="w-full" data-id="element-272">
            <thead className="bg-surface border-b border-border-base" data-id="element-273">
              <tr data-id="element-274">
                <th className="px-6 py-4 text-left text-sm font-semibold text-primary" data-id="element-275">
                  Titel
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-primary" data-id="element-276">
                  Interpret
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-primary" data-id="element-277">
                  Genre
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border-base" data-id="element-278">
              {filteredSongs.map((song, index) => <motion.tr key={`${song.title}-${index}`} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.3,
              delay: index * 0.02
            }} className="hover:bg-[var(--color-surface-hover)] transition-colors" data-id="element-279">
                  <td className="px-6 py-4 text-primary font-medium" data-id="element-280">
                    {song.title}
                  </td>
                  <td className="px-6 py-4 text-muted" data-id="element-281">{song.artist}</td>
                  <td className="px-6 py-4" data-id="element-282">
                    <div className="flex flex-wrap gap-1" data-id="element-283">
                      {song.tags.map(tag => <span key={tag} className="px-2 py-1 bg-[var(--color-accent-hover)] text-primary text-xs rounded border border-accent" data-id="element-284">
                          {tag}
                        </span>)}
                    </div>
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </motion.div>

        {/* Mobile Cards */}
        <motion.div {...fadeInUp} className="md:hidden space-y-4" data-id="element-285">
          {filteredSongs.map((song, index) => <motion.div key={`${song.title}-${index}`} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-surface border border-border-base rounded-lg p-4 hover:border-accent transition-colors" data-id="element-286">
              <div className="flex items-start gap-3" data-id="element-287">
                <MusicIcon size={20} className="text-accent opacity-50 mt-1 flex-shrink-0" data-id="element-288" />
                <div className="flex-1 min-w-0" data-id="element-289">
                  <h3 className="font-semibold text-primary mb-1" data-id="element-290">
                    {song.title}
                  </h3>
                  <p className="text-muted text-sm mb-2" data-id="element-291">{song.artist}</p>
                  <div className="flex flex-wrap gap-1" data-id="element-292">
                    {song.tags.map(tag => <span key={tag} className="px-2 py-1 bg-[var(--color-accent-hover)] text-primary text-xs rounded border border-accent" data-id="element-293">
                        {tag}
                      </span>)}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {filteredSongs.length === 0 && <motion.div {...fadeInUp} className="text-center py-12" data-id="element-294">
            <p className="text-muted" data-id="element-295">
              Keine Songs in dieser Kategorie gefunden.
            </p>
          </motion.div>}
      </div>
    </div>;
}